import { Component, ContentChild, EventEmitter, TemplateRef, Input, Output } from '@angular/core';
import { TemplateUuids } from '@mhe/ngx-shared/utils';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
import * as i2 from "./collapse.directive";
function CollapseComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r0.collapseUUID);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r0.title);
} }
function CollapseComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 6);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("id", ctx_r1.collapseUUID);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.title);
} }
function CollapseComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c0 = function (a0, a1) { return { "dpg-icon-accordion-close": a0, "dpg-icon-accordion-open": a1 }; };
export class CollapseComponent {
    constructor() {
        this.isCollapsed = true;
        this.isRowClickable = false;
        this.toggle = new EventEmitter();
        this.templateUuids = new TemplateUuids();
        console.warn('The component: CollapseComponent has been deprecated and will be removed in a future release. Please update your application to use the Collapse directive instead. https://s3.amazonaws.com/ngx-shared/branch/5.0.0-beta/open-learning/index.html#/collapse-directive');
    }
    get ariaLabel() {
        return this.isCollapsed ? this.expandLabel : this.collapseLabel;
    }
    get collapseUUID() {
        return this.templateUuids.get('collapseId');
    }
    toggleClick() {
        this.toggle.emit(this);
    }
}
CollapseComponent.ɵfac = function CollapseComponent_Factory(t) { return new (t || CollapseComponent)(); };
CollapseComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: CollapseComponent, selectors: [["mhe-collapse"]], contentQueries: function CollapseComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        i0.ɵɵcontentQuery(dirIndex, TemplateRef, 7);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentTemplate = _t.first);
    } }, inputs: { title: "title", isCollapsed: "isCollapsed", expandLabel: "expandLabel", collapseLabel: "collapseLabel", isRowClickable: "isRowClickable" }, outputs: { toggle: "toggle" }, decls: 7, vars: 13, consts: [[1, "dpg-ui-collapse-container"], ["type", "button", 3, "click"], [1, "ahe-icon", 3, "ngClass"], ["class", "dpg-ui-collapse-header", 3, "id", 4, "ngIf"], ["role", "region", 1, "dpg-ui-collapse-content", 3, "mheCollapse"], [4, "ngTemplateOutlet"], [1, "dpg-ui-collapse-header", 3, "id"]], template: function CollapseComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
        i0.ɵɵlistener("click", function CollapseComponent_Template_button_click_1_listener() { return ctx.toggleClick(); });
        i0.ɵɵelement(2, "i", 2);
        i0.ɵɵtemplate(3, CollapseComponent_span_3_Template, 2, 2, "span", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(4, CollapseComponent_span_4_Template, 2, 2, "span", 3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 4);
        i0.ɵɵtemplate(6, CollapseComponent_ng_container_6_Template, 1, 0, "ng-container", 5);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵclassProp("dpg-ui-row-button", ctx.isRowClickable);
        i0.ɵɵattribute("aria-labelledby", ctx.collapseUUID)("aria-label", ctx.ariaLabel)("aria-expanded", !ctx.isCollapsed);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(10, _c0, ctx.isCollapsed, !ctx.isCollapsed));
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.isRowClickable);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isRowClickable);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("mheCollapse", ctx.isCollapsed);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngTemplateOutlet", ctx.contentTemplate);
    } }, dependencies: [i1.NgClass, i1.NgIf, i1.NgTemplateOutlet, i2.CollapseDirective], styles: ["\n"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(CollapseComponent, [{
        type: Component,
        args: [{ selector: 'mhe-collapse', template: "<div class=\"dpg-ui-collapse-container\">\n  <button\n    type=\"button\"\n    [attr.aria-labelledby]=\"collapseUUID\"\n    [attr.aria-label]=\"ariaLabel\"\n    [attr.aria-expanded]=\"!isCollapsed\"\n    [class.dpg-ui-row-button]=\"isRowClickable\"\n    (click)=\"toggleClick()\"\n  >\n    <i\n      class=\"ahe-icon\"\n      [ngClass]=\"{ 'dpg-icon-accordion-close': isCollapsed, 'dpg-icon-accordion-open': !isCollapsed }\"\n    >\n    </i>\n\n    <span *ngIf=\"isRowClickable\" [id]=\"collapseUUID\" class=\"dpg-ui-collapse-header\">{{ title }}</span>\n  </button>\n  <span *ngIf=\"!isRowClickable\" [id]=\"collapseUUID\" class=\"dpg-ui-collapse-header\">{{ title }}</span>\n</div>\n<div role=\"region\" class=\"dpg-ui-collapse-content\" [mheCollapse]=\"isCollapsed\">\n  <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\n</div>\n", styles: ["/*# sourceMappingURL=collapse.component.css.map */\n"] }]
    }], function () { return []; }, { title: [{
            type: Input
        }], isCollapsed: [{
            type: Input
        }], expandLabel: [{
            type: Input
        }], collapseLabel: [{
            type: Input
        }], isRowClickable: [{
            type: Input
        }], contentTemplate: [{
            type: ContentChild,
            args: [TemplateRef, { static: true }]
        }], toggle: [{
            type: Output
        }] }); })();
